import httpClient from '@/lib/httpClient'
import { useMutation } from '@tanstack/react-query'

/**
 * Create a Stripe Checkout Session on the backend and return its URL.
 * The frontend only redirects the browser — it never handles Stripe ids/keys.
 */
export function useCreateCheckoutSession() {
  return useMutation({
    mutationFn: async ({
      teamId,
      planKey,
    }: {
      teamId?: string | number | null
      planKey?: string
    }) => {
      const response = await httpClient.post(
        'billing/checkout-session',
        planKey ? { plan_key: planKey } : {},
        { headers: teamId ? { 'X-Team': String(teamId) } : undefined },
      )
      return response.data as { url: string }
    },
  })
}

/** Stripe Billing Portal session — caller redirects to the returned URL. */
export function useCreatePortalSession() {
  return useMutation({
    mutationFn: async (teamId?: string | number | null) => {
      const response = await httpClient.post(
        'billing/portal-session',
        {},
        { headers: teamId ? { 'X-Team': String(teamId) } : undefined },
      )
      return response.data as { url: string }
    },
  })
}
